export const mediaQuery = {
  max_mobile: "@media (max-width: 767px)",
  min_tablet: "@media (min-width: 768px)",
  min_desktop: "@media (min-width: 1024px)",
  desktop_medium: "@media (min-width: 1600px)",
}
